import { Component, inject, OnInit, signal } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { VisualizationHistoryItem } from 'src/app/models/visualization-history';
import { from } from 'rxjs';
import { mergeMap, toArray } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { ConfigService } from 'src/app/services/config.service';
import { Router } from '@angular/router';
import { ToastService } from '../../../_core/services/toast.service';

@Component({
  selector: 'app-user-visualization-history',
  templateUrl: './user-visualization-history.component.html',
  styleUrls: ['./user-visualization-history.component.scss'],
})
export class UserVisualizationHistoryComponent implements OnInit {
  private readonly toastService = inject(ToastService);

  readonly showDeleteVisualizationHistoryDialog = signal<boolean>(false);

  section = 'visualizations';
  loading = true;
  userService: UserService;
  waiting: boolean;
  hasLoadMore: boolean;

  constructor(
    userService: UserService,
    configService: ConfigService,
    router: Router,
    private apiService: ApiService,
  ) {
    this.userService = userService;

    if (!configService.get().showVisualizationHistory) {
      router.navigate(['/user/checkouts']);
    }

    if (!this.userService.visualizationHistory.elements.length) {
      this.loadVisualizations();
    } else {
      this.hasLoadMore =
        this.userService.visualizationHistory.elements.length < this.userService.visualizationHistory.totalElements;
    }
  }

  ngOnInit() { }

  loadVisualizations(offset?: number) {
    this.apiService.getVisualizationHistory(this.userService.getUserId(), offset).subscribe((visualizations) => {
      if (offset) {
        visualizations.elements.unshift(...this.userService.visualizationHistory.elements);
      }

      this.loading = false;
      this.waiting = false;

      this.userService.visualizationHistory = visualizations;
      this.hasLoadMore = this.userService.visualizationHistory.elements.length < visualizations.totalElements;
    });
  }

  loadMore() {
    this.waiting = true;
    this.loadVisualizations(this.userService.visualizationHistory.elements.length);
  }

  deleteAll() {
    this.showDeleteVisualizationHistoryDialog.set(false);
    from(this.userService.visualizationHistory.elements)
      .pipe(
        mergeMap((visualization) =>
          this.apiService.removeVisualizationFromHistory(
            this.userService.getUserId(),
            visualization.id,
            visualization.visualizationType
          )
        ),
        toArray()
      )
      .subscribe(() => {
        this.toastService.showToast('messages.visualizationHistory.clear');
        this.userService.visualizationHistory.elements = [];
      });
  }

  onRemoved(visualization: VisualizationHistoryItem) {
    this.userService.removeVisualizationFromHistory(visualization);
  }
}
